define('gameday-index-gdaudio/GDIndexAudioComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-configurator/GamedayIndexConfigurator','gameday-index-enums/enums/events/LoadEvents','gameday-index-enums/enums/events/DisplayEvents','gameday-index-enums/enums/events/OauthEvents','gameday-index-url-hasher/UrlHasher','gid-decoder/GidDecoder','./subcomponents/AudioFeedDisplayUnit','./subcomponents/AudioPlaybackComponent','./subcomponents/MediaUrlFetcher','extant/extant','app-console/app-console','bam.cookies/cookies'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		SiteConfig = require("gameday-index-configurator/GamedayIndexConfigurator"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		DisplayEvts = require("gameday-index-enums/enums/events/DisplayEvents"),
		OauthEvts = require("gameday-index-enums/enums/events/OauthEvents"),
		UrlHash = require("gameday-index-url-hasher/UrlHasher"),
		GID = require("gid-decoder/GidDecoder"),
		AudioFeedDisplayUnit = require('./subcomponents/AudioFeedDisplayUnit'),
		PlaybackComponent = require("./subcomponents/AudioPlaybackComponent"),
		UrlFetcher = require("./subcomponents/MediaUrlFetcher"),
		exists = require("extant/extant"),
		logg = require("app-console/app-console"),
		cookies = require("bam.cookies/cookies"),
		timer;


	// instance variables
	var Superclass,
		feedDisplay,
		currentGID = null,
		feedsLoaded = false,
		feedList = {},
		selectedFeed = null,
		urler,
		audioPlayer,
		self,
		cacheFeeds;

	function GDAudio(compID, divID) {
		this.componentID = compID;
		this.targetDiv = divID;

		this.init();

	}

	BaseClass.spawn(GDAudio).define({
		init: function() {
			$(this.targetDiv).css("opacity", .5);
			dispatcher.publish(LoadEvts.componentReady, this.componentID);

			self = this;
			dispatcher.one("init_data_loaded", stageTwo);

			function stageTwo() {
				$(self.targetDiv).css("opacity", 1);

				self.buildAppSettings();
				self.setHandlers();
				self.initialized = true;

				dispatcher.addListener(LoadEvts.audioFeedsLoaded, self.setFeeds);
				dispatcher.addListener(LoadEvts.noAudioFeedsAvailable, self.setFeeds);
				dispatcher.addListener.call(self, DisplayEvts.audioFeedSelected, self.handleAudioFeedSelected);
				dispatcher.addListener(OauthEvts.isLogin, self.handleOauthEvts);
				dispatcher.addListener(OauthEvts.isNotLogin, self.handleOauthEvts);
				dispatcher.addListener(OauthEvts.isLoginNoEntitlement, self.handleOauthEvts);
				dispatcher.addListener("gdidx::destroyFeedList", self.removeFeedList);
				dispatcher.addListener(DisplayEvts.showLogoutButton, self.updateFeeds);

				dispatcher.addListener.call(self, DisplayEvts.playAuidoFeed, self.handlePlayableUrlReady);
			}
		},

		buildAppSettings: function() {
			urler = new UrlFetcher();
		},

		setHandlers: function() {
			var div = this.targetDiv;
			$(div).mouseover(function() {
				clearTimeout(timer);
				var gid = GID.decodeGID(UrlHash.getHashParams().game);
				var feedsReady = ((gid.gid === currentGID) && feedsLoaded);

				// if aren't already loaded set some vars for the future
				if (!feedsReady) {
					currentGID = gid.gid;
					feedsLoaded = false;
					feedList = null;
				}

				// init the feed display with what we have
				if (!exists(feedDisplay)) {
					feedDisplay = new AudioFeedDisplayUnit(div, gid, (feedsReady) ? feedList : null);
				}
				
				if (SiteConfig.getLoginStatus()) {
				  dispatcher.publish(DisplayEvts.showLogoutButton, true);
				}
				
			});

		},

		setFeeds: function($data) {
			feedList = (exists($data) && exists($data.mediaItems)) ? $data.mediaItems : {};
			feedList.combinedMediaState = (exists($data) && exists($data.combinedMediaState)) ? $data.combinedMediaState : "";
			feedsLoaded = true;
			if (exists(feedDisplay)) {
				feedDisplay.display(feedList);
			}
			cacheFeeds = $data;
			
			if (SiteConfig.getLoginStatus()) {
				 dispatcher.publish(DisplayEvts.showLogoutButton, true);
			}
		},
		
		
		updateFeeds: function(status) {
			var audioFeedsContainer = $(".audioFeedList");
			if (status && audioFeedsContainer.length > 0) {
			  var logoutBtn = audioFeedsContainer.find("#logoutButton");
			  
			  if (logoutBtn.hasClass("hide")) {
			     logoutBtn.removeClass("hide");
			  }
			  
			}
		},
		
		handleAudioFeedSelected: function(payload, evt) {
			selectedFeed = payload;
			logg.log(this.targetDiv);
			dispatcher.publish(OauthEvts.checkOauthStatus);
		},

		handleOauthEvts: function(payload, evt) {
			// handler for if message service is appending it's namespace... or not, in case it stops.
			var prefix = (evt.type.indexOf("MessageService") >= 0) ? "MessageService::" : "";

			switch (evt.type) {
				case prefix + OauthEvts.isLogin:
				    
					SiteConfig.setLoginStatus(true);
					dispatcher.publish(DisplayEvts.showLogoutButton, true);
					var calID = GDC.getGameData("linescore").linescore.game_media.calendar_event_id;
					if (selectedFeed) { urler.getURL(calID, selectedFeed.contentID) };
					break;
				case prefix + OauthEvts.isNotLogin:
					SiteConfig.setLoginStatus(false);
					logg.log("user needs to log in");
					break;
				case prefix + OauthEvts.isLoginNoEntitlement:
					SiteConfig.setLoginStatus(true);
					dispatcher.publish(DisplayEvts.showLogoutButton, true);
					logg.log("user needs to buy gd audio");
					break;
			}
		},

		handlePlayableUrlReady: function(payload, evt) {
			logg.log("LETS DO THIS AUDIO THANG!");
			if (!exists(audioPlayer)) {
				audioPlayer = new PlaybackComponent(this.targetDiv, selectedFeed, payload.url);
			} else {
				audioPlayer.loadFeed(selectedFeed, payload.url);
			}
		},

		removeFeedList: function() {
			try {
				feedDisplay.destroy();
				feedDisplay = null;
				$("body").off("mousemove");

				} catch (err) { }
		}
	});

	Superclass = GDAudio.superclass;
	return GDAudio;
});
